export default "__VITE_ASSET__NS3fFFyg__"